/// imports
import React from "react";
import { Helmet } from "react-helmet";
import { ReduxConnect } from "../../../toolkit/decorators/Artifact";
import Layout from "../../components/layout";
import ConveniosComponent from "../../components/convenios/index";
import {
  deleteConvenio,
  getConvenioMembresiasConteo,
  getConveniosList
} from "../../actions/convenios";
import { Preview } from "../../../types/IAction";
////

const mapDispatchToProps = dispatch => ({
  /// Dispatchers de convenios
  getConveniosList: (): Promise<Preview<any>> => {
    return dispatch(getConveniosList());
  },
  getConvenioMembresiasConteo: (idConvenio: number): Promise<Preview<any>> => {
    return dispatch(getConvenioMembresiasConteo(idConvenio));
  },
  deleteConvenio: (idConvenio: number): Promise<Preview<any>> => {
    return dispatch(deleteConvenio(idConvenio));
  }
  ////
});

const mapStateToProps = state => {
  const convenios = state.convenios;

  return {
    /// State de Convenios
    conveniosList: convenios.conveniosList,
    conveniosListLoading: convenios.conveniosListLoading,

    membresiaConteoLoading: convenios.membresiaConteoLoading,
    membresiaConteo: convenios.membresiaConteo,
    membresiaConteoError: convenios.membresiaConteoError,

    convenioDeleting: convenios.convenioDeleting,
    convenioDeletingError: convenios.convenioDeletingError
    ////
  };
};

interface Props {
  // Listado de Convenios (Redux)
  conveniosList: any[];
  conveniosListLoading: boolean;
  getConveniosList: () => Promise<Preview<any>>;
  getConvenioMembresiasConteo: (idConvenio: number) => Promise<Preview<any>>;
  deleteConvenio: (idConvenio: number) => Promise<Preview<any>>;
  membresiaConteoLoading: boolean;
  membresiaConteo: any;
  membresiaConteoError: string;
  convenioDeleting: boolean;
  convenioDeletingError: string;
}

interface State {}

@ReduxConnect(mapStateToProps, mapDispatchToProps)
export default class ConveniosContainer extends React.Component<Props, State> {
  state = {
    useError: false
  };

  componentDidMount() {
    this.props.getConveniosList();
  }

  render() {
    return (
      <main>
        <Layout>
          <Helmet title="Convenios" />
          <ConveniosComponent
            getConveniosList={this.props.getConveniosList}
            getConvenioMembresiasConteo={this.props.getConvenioMembresiasConteo}
            deleteConvenio={this.props.deleteConvenio}
            conveniosList={this.props.conveniosList}
            conveniosListLoading={this.props.conveniosListLoading}
            membresiaConteoLoading={this.props.membresiaConteoLoading}
            membresiaConteo={this.props.membresiaConteo}
            membresiaConteoError={this.props.membresiaConteoError}
            convenioDeleting={this.props.convenioDeleting}
            convenioDeletingError={this.props.convenioDeletingError}
          />
        </Layout>
      </main>
    );
  }
}
